import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { Button, Card } from "@/components/ui";

/**
 * What a render error shows instead of the router's bare default.
 *
 * Deliberately plain: the error itself is in the console for whoever debugs
 * it, and a stack trace is not something a person can act on.
 */
export function RouteError({ error }: { error: unknown }) {
  const { t } = useTranslation("shell");
  console.error(error);

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-5">
      <Card className="max-w-[460px] p-6 text-center">
        <AlertTriangle size={22} className="mx-auto text-warning" aria-hidden="true" />
        <h1 className="mt-3 text-[15px] font-semibold text-text">{t("routeError.title")}</h1>
        <p className="mt-1.5 text-[13.5px] leading-relaxed text-text-muted">
          {t("routeError.body")}
        </p>
        <div className="mt-5 flex justify-center gap-2">
          <Button variant="primary" onClick={() => window.location.reload()}>
            {t("routeError.reload")}
          </Button>
          <Button variant="ghost" onClick={() => window.location.assign("/")}>
            {t("routeError.home")}
          </Button>
        </div>
      </Card>
    </div>
  );
}
